import React from "react";
import { CountDown } from "@al/akui-mobile";
import cls from "classnames";

import styles from "./styles.scss";

type Props = {
  endTime: number;
  onTimeOver?: () => void;
  className?: string;
  style?: React.CSSProperties;
};

function ProductCountDown(props: Props): JSX.Element {
  const { endTime, onTimeOver, className, style } = props;

  const onTimeOverHandler = (): void => {
    onTimeOver?.();
  };

  return (
    <CountDown endTime={endTime} onTimeOver={onTimeOverHandler}>
      {(timeInfo): React.ReactNode => {
        return (
          <>
            <div className={cls(styles.count_down, "al_font_bold", className)} style={style}>
              <span className={styles.count_down_time_item}>{Number(timeInfo.hoursStr) + timeInfo.day * 24}</span>
              <span className={styles.count_down_time_split}>:</span>
              <span className={styles.count_down_time_item}>{timeInfo.minutesStr}</span>
              <span className={styles.count_down_time_split}>:</span>
              <span className={styles.count_down_time_item}>{timeInfo.secondsStr}</span>
            </div>
          </>
        );
      }}
    </CountDown>
  );
}

export default ProductCountDown;
